<template>
  <ConsigneeInfo :consignee="barrel.Consignee" />
</template>

<script>
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import ConsigneeInfo from "@/components/ConsigneeInfo.vue";
import mixins from "vue-typed-mixins";

export default mixins(SnackbarNotifierMixin).extend({
  name: "Consignee",
  components: {
    ConsigneeInfo,
  },
  data() {
    return {
      barrelId: "",
      barrel: {},
    };
  },
  methods: {
    async getDetails() {
      try {
        let result = await ApiService.Instance.barrelDetails({
          logicalBarrelId: this.barrelId,
        });
        if (result)
          this.showNotifier({
            message: `Recipient's Info Retrieved`,
            snackbarType: "success",
          });
        this.barrel = result.barrel;
      } catch (e) {
        this.showNotifier({
          message: `Failed To Load Recipient's Info`,
          snackbarType: "error",
        });
        error(e);
      }
    },
  },
  async beforeMount() {
    try {
      this.barrelId = this.$route.params.barrelId;
      await this.getDetails();
    } catch (e) {
      error(e);
    }
  },
});
</script>
